import { ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { ObjectSelectInput, ObjectSelectProps } from '@frontend/components/basic-forms';
import { CommonMessage } from '@frontend/lang';
import { WizardClient } from '@frontend/wizard/api';
import { Wizard, WizardListResponse, WizardQueryParams } from '@frontend/wizard/types';
import React, { useState } from 'react';

const ID = 'wizard-select';
export interface WizardSelectProps extends ObjectSelectProps<Wizard, WizardQueryParams> {
    fetch?: (queryParams?: ApiQueryParams<DefaultQueryParams & WizardQueryParams>) => Promise<WizardListResponse>;
}

export const WizardSelect = (props: WizardSelectProps) => {
    const [v, cV] = useState<Wizard | null>(null);
    return (
        <ObjectSelectInput<Wizard, WizardQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            label={props.label || CommonMessage.OBJECTS.WIZARD.DEFAULT}
            className={props.className}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                props.onChangeObject && props.onChangeObject(v);
                cV(v);
            }}
            required={props.required}
            queryParams={props.queryParams}
            value={v}
            idValue={props.value || v?.id}
            fetch={props.fetch ? (args) => props.fetch!(args) : (args) => WizardClient.fetchWizards(args)}
            itemLabel={(i) => (props.overWriteLabel ? props.overWriteLabel(i) : i.name)}
        />
    );
};
